import { motion } from "framer-motion";
import { Star, MoonStar } from "lucide-react";
import { useLang } from "../i18n";
import { TESTIMONIALS } from "../siteData";

export function Testimonials() {
    const { lang, t } = useLang();
    return (
        <section id="reviews" className="relative border-y border-white/10 bg-[#0e0e13] py-28" data-testid="testimonials-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 36 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                >
                    <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#FFB800]">{t.reviews.overline}</p>
                    <h2 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
                        {t.reviews.title}
                    </h2>
                </motion.div>

                <div className="mt-12 grid gap-5 md:grid-cols-3">
                    {TESTIMONIALS.map((r, i) => (
                        <motion.figure
                            key={r.name}
                            initial={{ opacity: 0, y: 36 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="flex flex-col rounded-3xl border border-white/10 bg-[#13131A] p-7"
                        >
                            <div className="flex gap-1">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star key={s} size={15} className="fill-[#FFB800] text-[#FFB800]" />
                                ))}
                            </div>
                            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#c9c9d4]">
                                “{lang === "zh" ? r.quote_zh : r.quote_en}”
                            </blockquote>
                            <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                                <img src={r.avatar} alt={r.name} loading="lazy" className="h-11 w-11 rounded-full border border-[#FFB800]/40 object-cover" />
                                <div className="flex-1">
                                    <p className="text-sm font-semibold text-[#F4F4F6]">{r.name}</p>
                                    <p className="text-xs text-[#8E8EA0]">{lang === "zh" ? r.role_zh : r.role_en}</p>
                                </div>
                                <span className="inline-flex items-center gap-1 rounded-full border border-[#FF2E4D]/30 px-2.5 py-1 font-mono2 text-[10px] text-[#FF2E4D]">
                                    <MoonStar size={10} />
                                    {r.time}
                                </span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
